var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingBottomButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18546",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18546",
    transform: "translate(19822 5573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "setting",
    d: "M92.015,75.52a15.642,15.642,0,0,0,.128-2.5c0-.876-.128-1.626-.128-2.5l5.372-4.128a1.149,1.149,0,0,0,.256-1.626l-5.118-8.632a1.246,1.246,0,0,0-1.536-.5l-6.4,2.5a18.621,18.621,0,0,0-4.349-2.5L79.348,49a1.371,1.371,0,0,0-1.28-1H67.834a1.371,1.371,0,0,0-1.279,1l-1.023,6.629a21.666,21.666,0,0,0-4.35,2.5l-6.4-2.5a1.2,1.2,0,0,0-1.536.5L48.13,64.763a1.511,1.511,0,0,0,.256,1.626l5.5,4.128c0,.876-.127,1.626-.127,2.5s.127,1.626.127,2.5l-5.372,4.128a1.149,1.149,0,0,0-.256,1.626l5.118,8.632a1.246,1.246,0,0,0,1.536.5l6.4-2.5a18.621,18.621,0,0,0,4.349,2.5l1.023,6.629a1.24,1.24,0,0,0,1.279,1H78.2a1.371,1.371,0,0,0,1.279-1L80.5,90.406a21.654,21.654,0,0,0,4.349-2.5l6.4,2.5a1.2,1.2,0,0,0,1.536-.5L97.9,81.273a1.509,1.509,0,0,0-.256-1.626L92.015,75.52ZM72.951,81.774a8.758,8.758,0,1,1,8.956-8.756A8.8,8.8,0,0,1,72.951,81.774Z",
    transform: "translate(-19863.998 -5615.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17431",
    "data-name": "\\u9577\\u65B9\\u5F62 17431",
    width: 62,
    height: 62,
    transform: "translate(-19822 -5573)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingBottomButton);
export default __webpack_public_path__ + "static/media/settingBottomButton.94a21eca0a01725f473167fde9cb52e2.svg";
export { ForwardRef as ReactComponent };